import React, { useContext, useEffect, useState } from 'react'
import ReactDOM from 'react-dom';
import Popup from '../components/Popup/Popup';
import ConfirmPopup from '../components/Popup/ConfirmPopup';
export const ModalContext = React.createContext({
  
})

export const ModalProvider = ({ children }) => {
    const [modalContent, setModalContent] = useState(null);
    const [modalConfirmContent, setModalConfirmContent] = useState(null);
    const [modalFooter, setModalFooter] = useState(null);
    const [modalBackTo, setModalBackTo] = useState(null);
    const [modalForce, setModalForce] = useState(false);
    const [confirmProps, setConfirmProps] = useState(null);
    const [tempData, setTempData] = useState(null);
    const openModal = (content, isNew = true, backTo = null, footer = null) => {
        setConfirmProps(null);
        setModalBackTo(backTo);
        if(!isNew){
            setModalFooter(() => footer);
            setModalContent(() => content);
            return;
        }
        setModalFooter(footer);
        setModalContent(content)
    };
    const openForceModal = (content) => {
        setModalForce(true);
        setConfirmProps(null);
        setModalBackTo(null);
        setModalFooter(null);
        setModalContent(content)
    };
    const closeForceModal = () => {
        setConfirmProps(null);
        setModalContent(null);
        setModalBackTo(null);
        setModalForce(false)
    }
    const openConfirm = (message, onOk = () => {}, onCancel = () => {}, okLabel = null, cancelLabel = null) => {
        setTempData(null);
        setConfirmProps({
            onOk,
            onCancel,
            okLabel,
            cancelLabel
        })
        setModalConfirmContent(message)
    };
    const closeConfirmModal = () => {
        setTempData(null);
        setConfirmProps(null);
        setModalConfirmContent(null);
        setModalBackTo(null);
        setModalForce(false)
    };
    const closeModal = () => {
        setConfirmProps(null);
        setModalContent(null);
        setModalBackTo(null);
        setModalForce(false)
    };
    const showPopupMessage = (message, onOk = () => {}, okLabel = null) => {
        setConfirmProps({
            onOk,
            onCancel: null,
            okLabel,
            cancelLabel: null
        })
        setModalContent(message)
    };
    return (
      <ModalContext.Provider value={{ 
            openModal, 
            closeModal, 
            closeConfirmModal, 
            openConfirm, 
            showPopupMessage, 
            modalBackTo, 
            modalForce,
            openForceModal,
            closeForceModal,
            setTempData,
            tempData
      }}>
        {children}
        {modalContent &&
            ReactDOM.createPortal(<Popup footer={modalFooter}>{modalContent}</Popup>,
            document.getElementById('root')
        )}
        {modalConfirmContent &&
            ReactDOM.createPortal(<ConfirmPopup {...confirmProps}>{modalConfirmContent}</ConfirmPopup>,
            document.getElementById('root')
        )}
            
      </ModalContext.Provider>
    );
    
};
